import { IdentifierType } from '../enum/identifier-type.enum';

export class IdentifierValidatorsUtil {
	/*
	** Use ^ and $ to indicate that it should be the start and end of a phrase
	** An isin should should start with 2 letters - [A-Z]{2}
	** Followed by nine uppercase letters or digits - [A-Z0-9]{9}
	** Finally one digit [0-9]
	*/
	public static validateIsin(isin: string): boolean {
		isin = (isin || '').trim().toUpperCase();
		const isinRegex = new RegExp('^[A-Z]{2}[A-Z0-9]{9}\\d$');
		return isinRegex.test(isin);
	}

	/*
	** Use ^ and $ to indicate that it should be the start and end of a phrase
	** A sedol should contain 6 digits or letters not including any vowels - [0-9BCDFGHJKLMNPQRSTVWXYZ]{6}
	** Finally one digit [0-9]
	*/
	public static validateSedol(sedol: string): boolean {
		sedol = (sedol || '').trim().toUpperCase();
		const sedolRegex = new RegExp('^[0-9BCDFGHJKLMNPQRSTVWXYZ]{6}\\d$');
		return sedolRegex.test(sedol);
	}

	/*
	** Use ^ and $ to indicate that it should be the start and end of a phrase
	** A cusip should start with 3 digits - [0-9]{3}
	** Followed by two uppercase letters or digits - [A-Z0-9]{2}
	** Followed by three uppercase letters, digits or specific special characters - [A-Z0-9*@#]{3}
	** Finally one digit [0-9]
	*/
	public static validateCusip(cusip: string): boolean {
		cusip = (cusip || '').trim().toUpperCase();
		const cusipRegex = new RegExp('^[0-9]{3}[A-Z0-9]{2}[A-Z0-9*@#]{3}\\d$');
		return cusipRegex.test(cusip);
	}

	/*
	** Use ^ and $ to indicate that it should be the start and end of a phrase
	** A bCusip should contain 9 alphanumeric characters - [A-Z0-9]{9}
	*/
	public static validateBCusip(bCusip: string): boolean {
		bCusip = (bCusip || '').trim().toUpperCase();
		const bCusipRegex = new RegExp('^[A-Z0-9]{9}$');
		return bCusipRegex.test(bCusip);
	}

	/*
	** Use ^ and $ to indicate that it should be the start and end of a phrase
	** A ticker should contain 1-5 letters - [A-Z]{1,5}
	*/
	public static validateTicker(ticker: string): boolean {
		ticker = (ticker || '').trim().toUpperCase();
		const tickerRegex = new RegExp('^[A-Z]{1,5}$');
		return tickerRegex.test(ticker);
	}

	/*
	**	^ asserts the position at the start of the string.
	**	F\d{5}[A-Z0-9]{4} matches strings starting with “F” followed by exactly five digits and then four alphanumeric characters.
	**	| acts as an OR operator.
	**	(F[O|E|C]USA|SAUSA)[A-Z0-9]{5} matches strings starting with “F(O/C/E)USA” or “SAUSA” followed by exactly five alphanumeric characters.
	**	$ asserts the position at the end of the string.
	*/
	public static validateMorningstarSecId(mstarSecId: string): boolean {
		mstarSecId = (mstarSecId || '').trim().toUpperCase();
		const mstarSecIdRegex = new RegExp('^(F\\d{5}[A-Z0-9]{4}|(F[O|C|E]USA|SAUSA)[A-Z0-9]{5})$');
		return mstarSecIdRegex.test(mstarSecId);
	}

	/*
	** Calculate identifier type from identifier
	*/
	public static getIdentifierTypeFromIdentifier(identifier: string): string {
		if (IdentifierValidatorsUtil.validateTicker(identifier)) {
			return IdentifierType.ticker;
		} else if (IdentifierValidatorsUtil.validateIsin(identifier)) {
			return IdentifierType.isin;
		} else if (IdentifierValidatorsUtil.validateCusip(identifier)) {
			return IdentifierType.cusip;
		} else if (IdentifierValidatorsUtil.validateBCusip(identifier)) {
			return IdentifierType.cusip;
		} else if (IdentifierValidatorsUtil.validateSedol(identifier)) {
			return IdentifierType.sedol;
		} else if (IdentifierValidatorsUtil.validateMorningstarSecId(identifier)) {
			return IdentifierType.morningstarSecId;
		} else {
			return IdentifierType.ticker;
		}
	}
}
